import { useAuth0 } from '@auth0/auth0-react';

import { Button } from '@/components/ui/button';
import { getConfig } from '@/config';
import { APP_ROUTES } from '@/constants/routes';

/**
 * User-gated last-resort recovery for the companion auth flow. Rendered on the
 * terminal error screen only when a re-login could actually re-run the flow (the
 * param stash is still present). Because it is user-initiated, it is intentionally
 * NOT gated by the one-shot retry cap that guards the automatic recovery paths.
 */
export const ManualRetryButton = () => {
  const { loginWithRedirect } = useAuth0();

  const handleClick = () => {
    void loginWithRedirect({
      authorizationParams: {
        prompt: 'login',
        redirect_uri: `${getConfig().AUTH.auth0RedirectUrl}${APP_ROUTES.EXTERNAL_AUTH}`,
      },
      appState: { returnTo: APP_ROUTES.EXTERNAL_AUTH },
    });
  };

  return (
    <Button
      className="w-full max-w-sm"
      data-testid="manual-retry-button"
      size="lg"
      variant="burgundy"
      onClick={handleClick}
    >
      Sign in again
    </Button>
  );
};
